import Vue from 'vue'
import App from '@/App.vue'
import http from '@/http';
import store from '@/store';
import _ from 'underscore';
import router, {addMenu} from "@/router/route";
import VEmojiPicker from 'v-emoji-picker';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
// 引入你的主题配置样式（必须在 Element UI 默认样式之后）
import '@/theme/element-theme.scss'


import Common from "@/core/utils/common";
import stringUtil from '@/core/utils/string';
import DateUtil from '@/core/utils/date';
import Theme from '@/theme/theme';
import '@/core/utils/uuid';   // 触发 uuid.js 末尾的 `Vue.prototype.$UUID = new UUID()` 副作用

import Storage from '@/core/utils/storage.js';
import VueI18n from 'vue-i18n';
import lang from '@/common/lang';
import log from '@/common/log';
import socket from "@/common/js/socket";
import Config from '@/core/config/config';
import ToolUtil from '@/common/js/toolUtil';

import "@/app.scss";
import "@/common/css/iconfont/iconfont.css";
import "@/common/css/animate-3.7.2.css";
import chatApi from '@/im-http/index.js';
import storage from "@/core/utils/storage";
import ECharts from 'vue-echarts/components/ECharts.vue'
import XdPhoneInput from '@/components/xd-phone-input/xd-phone-input.vue'
import VueCropper from 'vue-cropper'
import '@/directive/index';

import 'echarts/lib/chart/line'
import 'echarts/lib/component/tooltip'

Vue.component('v-chart', ECharts);
Vue.component('xd-phone-input', XdPhoneInput);
Vue.use(VueCropper);
Vue.use(VEmojiPicker);

// import AutoRegister from '@/components/auto-register';
// Vue.use(AutoRegister);

// 在 main.js 中
const componentsContext = require.context(
    '@/components',
    true,
    /[A-Z]\w+\.vue$/ // 匹配 PascalCase 命名的组件文件
);

componentsContext.keys().forEach((fileName) => {
    const componentConfig = componentsContext(fileName);
    const componentName = componentConfig.default.name ||
        fileName.match(/([A-Z]\w+)\.vue$/)[1];
    Vue.component(componentName, componentConfig.default);
});

Vue.config.devtools = Config.isDevelopment();

Vue.config.productionTip = false;
Vue.prototype.$Api = http; //api的入口
Vue.prototype.$ChatApi = chatApi;
Vue.prototype.$_ = _;
Vue.prototype.$Storage = Storage;
Vue.prototype.$log = log;
Vue.prototype.$socket = socket;
Vue.prototype.$toolUtil = ToolUtil;
// 其它工具 ($Common / $StringUtil / $DateUtil / $Theme) 已在各自模块末尾通过
// `export default Vue.prototype.$Xxx = ...` 自挂载，无需在此重复。
// $UUID 通过上方 `import '@/core/utils/uuid'` 触发同样的自挂载副作用。
Vue.use(VueI18n);
const i18n = new VueI18n({
    locale: 'zh_cn', // 默认语言为中文
    messages: lang
});
Vue.prototype._i18n = i18n;
Vue.use(ElementUI,
    {
        i18n: (key, value) => i18n.t(key, value) // 在注册Element时设置i18n的处理方法
    }
);

Vue.directive('alterELDialogMarginTop'/*修改elementUI中el-dialog顶部的距离,传入值eg:{marginTop:'5vh'} */, {
    inserted(el, binding, vnode) {
        el.firstElementChild.style.marginTop = binding.value.marginTop
    }
});

Vue.filter('money', function (value) {
    if (!value) return '0.00';
    // 将数值截取，保留两位小数
    value = value.toFixed(2);
    // 获取整数部分
    const intPart = Math.trunc(value);
    // 整数部分处理，增加,
    const intPartFormat = intPart
        .toString()
        .replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
    // 预定义小数部分
    let floatPart = '.00';
    // 将数值截取为小数部分和整数部分
    const valueArray = value.toString().split('.');
    if (valueArray.length === 2) {
        // 有小数部分
        floatPart = valueArray[1].toString(); // 取得小数部分
        return intPartFormat + '.' + floatPart;
    }
    return intPartFormat + floatPart;
})
Vue.filter('intMoney', function (value) {
    if (!value && value !== 0) return '0';
    // 四舍五入到两位小数
    value = Math.round(Number(value) * 100) / 100;
    // 格式化整数部分
    const intPartFormat = value.toLocaleString('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
    });
    // 如果是整数或者小数部分为.00，则返回不带小数点的值
    if (value % 1 === 0) {
        return intPartFormat.split('.')[0];
    }
    return intPartFormat;
})
let token = storage.get('token');
if (token) {
    if (!store.state.contact.length) {
        //都没登陆调什么获取朋友
        // chatApi.getFriend().then(res => {
        //     if (res.code === 'success') {
        //         store.commit('setContact', res.data);
        //     }
        // });
    }
    addMenu(storage.get('userId'));
}

new Vue({
    render: h => h(App),
    store,
    router,
    i18n
}).$mount('#app');
